import ScrollIndicator from './theme/document/ScrollIndicator';
import MobileNavigation from './theme/navigation/MobileNavigation';
import HeaderNavigation from './theme/navigation/HeaderNavigation';
import StickyNavigation from './theme/navigation/StickyNavigation';
import Table from './theme/content/Table';
import { Slider } from '@parship/psg-slider';

new StickyNavigation();
new MobileNavigation(document.body);
new ScrollIndicator(document.body);
new Table();

let targets: NodeListOf<HTMLElement>;

targets = document.querySelectorAll(
	'.current-menu-item .psg-slider, .current-menu-parent .psg-slider'
);
targets.forEach((item: HTMLElement) => {
	new HeaderNavigation(item);
});

targets = document.querySelectorAll(
	'.magazine-slider, .success-stories.psg-slider, .studies-slider'
);

targets.forEach((item: HTMLElement) => {
	new Slider({ target: item, loop: true, itemsPerView: 1 });
});

targets = document.querySelectorAll('.single-portraits.psg-slider');

targets.forEach((item: HTMLElement) => {
	new Slider({
		target: item,
		loop: true,
		itemsPerView: 1,
		breakpoints: {
			600: {
				itemsPerView: 2,
			},
			768: {
				itemsPerView: 3,
			},
		},
	});
});
